import * as React from 'react';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography/Typography';
import * as styles from './DebtPayoffTracker.css';
import { PayoffDebt } from '../../ducks/debtPayoff';
import { dummyPayoffs } from '../dummyData/dummyPayoffs';


type PayoffStrategyProps = {
  debts: PayoffDebt[];
  option: string;
  extraPayment: number;
  currentTotalPayments: number;
  strategyTotalPayments: number;
  payoffDebtFreeMonths: number;
  currentDebtFreeMonths: number;
};

const PayoffStrategy = ({debts, option, extraPayment, currentTotalPayments, strategyTotalPayments, payoffDebtFreeMonths, currentDebtFreeMonths}: PayoffStrategyProps) => {

  const [estimatedSavings, setEstimatedSavings] = useState(0);
  const [priorityDebt, setPriorityDebt] = useState(debts[0]);
  const totalMonthlyPayment = debts.reduce((acc: number, debt) => {
    return +acc + +debt.minimum_payment;
  }, 0);
  const noPayoff = 'With current minimum payments, you will not pay off your debt.';


  const getPriorityAccountAvalanche = (): PayoffDebt => {
    // return the debt with the highest interest rate
    const updatedDebts = debts.filter(debt => debt.status !== 'paidOff');
    return updatedDebts.reduce((acc, debt) => {
      return +acc.interest_rate > +debt.interest_rate ? acc : debt;
    });
  };
  const getPriorityAccountSnowball = (): PayoffDebt => {
    // return the debt with the lowest balance
    const updatedDebts = debts.filter(debt => debt.status !== 'paidOff');
    return updatedDebts.reduce((acc, debt) => {
      return +acc.current_balance < +debt.current_balance ? acc : debt;
    });
  };

  const priorityDebtPayment = +priorityDebt.minimum_payment + +extraPayment;

  useEffect(() => {
    // console.log('currentTotalPayments', currentTotalPayments);
    // console.log('strategyTotalPayments', strategyTotalPayments);
    setPriorityDebt((option === 'avalanche') ? getPriorityAccountAvalanche() : getPriorityAccountSnowball());
    setEstimatedSavings(Math.floor(Number(currentTotalPayments) - Number(strategyTotalPayments)));
  }, []);


  return (
    <div>
      <Typography variant='h5' style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Your Payoff Strategy
      </Typography>
      <div className={styles.strategyContainer}>
        <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', marginTop: '1rem', color: '#00838f' }}>
          Priority Account: {priorityDebt.name}
        </Typography>
        <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', marginTop: '1rem', color: '#00838f' }}>
          Priority Account Payment: ${priorityDebtPayment ? priorityDebtPayment : 0}/month
        </Typography>
        {debts.length > 1 ?
          <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '1rem' }}>
            Other Debt Payments
          </Typography> : ''
        }
        {debts.map((payment, index) => {
          if (payment.id === priorityDebt.id) {
            return null;
          }
          if (payment.status === 'paidOff') {
            return (
              <div key={index} className={styles.strategy}>
                <Typography style={{ textAlign: 'center', marginBottom: '1rem' }}>
                  {payment.name}: Paid Off
                </Typography>
              </div>
            );
          }

          return (
            <div key={index} className={styles.strategy}>
              <Typography style={{ textAlign: 'center', marginBottom: '1rem' }}>
                {payment.name}: ${payment.minimum_payment}/month
              </Typography>
            </div>
          );
        })}
        <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', marginTop: '1rem' }}>
          Total Monthly Payments ${(totalMonthlyPayment + extraPayment).toString()}
        </Typography>
        <div className={styles.debtFree}>
          {
            payoffDebtFreeMonths <= 0 ?
              <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', color: '#d13f3f' }}>{noPayoff}</Typography> :
              <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Estimated Debt Payoff: <br />
                <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', color: '#78b638' }}>{payoffDebtFreeMonths} Months</Typography>
              </Typography>
          }
          {
            currentDebtFreeMonths <= 0 ?
              '' :
              <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Estimated Savings: <br />
                <Typography variant='h6' style={{ fontWeight: 'bold', textAlign: 'center', color: '#78b638' }}>${estimatedSavings}</Typography>
              </Typography>
          }
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any, ownProps: any) => {
  // Directly check your Redux state flag for dummy payoff data
  const showDummyDataPayoff = state.user.data.showDummyDataPayoff;
  if (showDummyDataPayoff) {
    return { ...ownProps, debts: dummyPayoffs };
  }
  return ownProps;
};

export default connect(mapStateToProps)(PayoffStrategy);